import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MODULES } from "@/lib/api";
import { Loading } from "@/components/dash";
import { PageHero } from "@/pages/site/ContentPage";
import { SubscribePanel } from "@/components/SubscribePanel";
import { useCatalog } from "@/components/ProductGate";

export default function Subscribe() {
  const [params] = useSearchParams();
  const [module, setModule] = useState(params.get("module") || "demand");
  const product = params.get("product");
  const coupon = params.get("renew") || "";
  const { data: cat } = useCatalog(module);
  const btn = (on) => `px-3 py-2 rounded-md border text-sm transition-colors text-left ${on ? "border-[#1074BA] bg-[#1074BA]/15 text-white" : "border-slate-700 text-slate-400 hover:text-white"}`;

  return (
    <div>
      <PageHero eyebrow="Subscribe" title="Dashboard subscriptions" subtitle="Subscribe per module and per product, globally or for selected regions. Access starts instantly after payment." />
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-12 space-y-6">
        <div className="grid sm:grid-cols-5 gap-2">{MODULES.map((m) => <button key={m.id} data-testid={`subscribe-module-${m.id}`} className={btn(module === m.id)} onClick={() => setModule(m.id)}>{m.label}</button>)}</div>
        {cat?.module === module ? <SubscribePanel key={module} module={module} cat={cat} initial={product && module === params.get("module") ? [product] : []} coupon={module === params.get("module") ? coupon : ""} /> : <Loading />}
      </div>
    </div>
  );
}
